
import { DBMessage } from "@/types/message";
import { Conversation } from "@/types/conversation";

/**
 * Prepares conversation context for regenerating AI responses
 */
export const prepareConversationContext = (
  conversation: Conversation | null,
  messages: DBMessage[],
  messageId: string
) => {
  if (!conversation) {
    console.error("Cannot regenerate: missing conversation");
    return null;
  }
  
  // Find the message to regenerate
  const messageToRegenerate = messages.find(msg => msg.id === messageId);
  if (!messageToRegenerate || messageToRegenerate.sender_type !== "ai") {
    console.error(`Invalid message to regenerate: ${messageId}, sender_type: ${messageToRegenerate?.sender_type}`);
    return null;
  }
  
  console.log(`Found message to regenerate: ${messageId}`);
  console.log(`Message content excerpt: ${messageToRegenerate.content.substring(0, 50)}...`);
  
  // Find message position in history
  const messageIndex = messages.findIndex(msg => msg.id === messageId);
  if (messageIndex === -1) {
    return null;
  }
  
  // Get all messages before this one for context
  const previousMessages = messages.slice(0, messageIndex);
  
  // Determine if this is the first AI message (initial response) or a reply to a seller message
  const sellerMessagesBefore = previousMessages.filter(msg => msg.sender_type === "seller");
  const isInitialResponse = sellerMessagesBefore.length === 0;
  
  // Find the most recent seller message before this AI message (if any)
  let sellerResponse = "";
  if (!isInitialResponse) {
    // Get the most recent seller message before this AI message
    const recentSellerMessages = [...previousMessages]
      .reverse()
      .filter(msg => msg.sender_type === "seller");
      
    if (recentSellerMessages.length > 0) {
      sellerResponse = recentSellerMessages[0].content;
      console.log(`Found seller message to respond to: ${sellerResponse.substring(0, 50)}...`);
    }
  }
  
  return {
    messageToRegenerate,
    previousMessages,
    isInitialResponse,
    sellerResponse,
    messageIndex
  };
};
